import { useEffect, useState } from "react";
import { ProgramMembership, UpdateProgramMembershipsInput } from "../../API";
import { QueryStatus } from "../../app/types";
import { MembershipPreview } from "../Users/EditUser";
import {
  fetchMembershipsByUserId,
  updateProgramMemberships
} from "./membershipAPI";

export const useMembershipsByUserId = (id: string | undefined) => {
  const [memberships, setMemberships] = useState<ProgramMembership[] | null>(
    null
  );
  const [status, setStatus] = useState<QueryStatus>("idle");
  const [error, setError] = useState<string | null>();

  const getMembershipsByUserId = async (id: string) => {
    setStatus("loading");
    setError(null);

    try {
      const results = await fetchMembershipsByUserId(id);
      setMemberships(results);
      setStatus("succeeded");
    } catch (error) {
      setStatus("failed");
      setError(`Error loading memberships: ${error}`);
    }
  };

  useEffect(() => {
    if (id) {
      getMembershipsByUserId(id);
    }
  }, [id]);

  return {
    memberships,
    status,
    error
  };
};

export const useUpdateMemberships = () => {
  const [updatedMemberships, setUpdatedMemberships] = useState<
    ProgramMembership[] | null
  >(null);
  const [status, setStatus] = useState<QueryStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  /**
   *
   * @param userId - ID of the user in question
   * @param updatedMemberships - The memberships present on the Edit User screen
   */
  const updateMemberships = async (
    userId: string,
    updatedMemberships: MembershipPreview[]
  ) => {
    setStatus("loading");
    setError(null);
    try {
      const input: UpdateProgramMembershipsInput = {
        userId,
        programMemberships: updatedMemberships.map((um) => ({
          id: um.id,
          programId: um.programId,
          programRole: um.programRole,
          traineeType: um.traineeType,
          endDate: um.endDate,
          startDate: um.startDate
        }))
      };
      const result = await updateProgramMemberships(input);
      if (result) {
        if (result.success) {
          setStatus("succeeded");
        } else {
          setStatus("failed");
          setError(result.error ?? "");
        }

        return result;
      } else {
        setStatus("failed");
        setError("Generic Error");
      }
    } catch (error) {
      let errorMessage = error;
      if (error instanceof Error && error.message) errorMessage = error.message;
      const errorString = `Error updating memberships: ${errorMessage}`;
      console.error("error updating memberships", error);
      setStatus("failed");
      setError(errorString);
    }
  };

  return {
    updatedMemberships,
    status,
    error,
    updateMemberships
  };
};
